import {
  collection,
  doc,
  getDocs,
  writeBatch,
  arrayUnion,
} from "firebase/firestore";
import { db } from "./firebase";

/**
 * Marks a chat as read by the given user.
 * Updates last_reply_read_by on the chat doc and read_by on all unread replies.
 */
export async function markChatAsRead(
  householdId: string,
  chatId: string,
  userId: string
): Promise<void> {
  // Update last_reply_read_by on the chat doc
  const chatRef = doc(db, "households", householdId, "chats", chatId);
  const batch = writeBatch(db);
  batch.update(chatRef, { last_reply_read_by: arrayUnion(userId) });

  // Get all replies and batch update read_by for unread ones
  const repliesRef = collection(
    db,
    "households",
    householdId,
    "chats",
    chatId,
    "replies"
  );
  const snapshot = await getDocs(repliesRef);
  snapshot.docs.forEach((d) => {
    const readBy: string[] = d.data().read_by || [];
    if (!readBy.includes(userId)) {
      batch.update(d.ref, { read_by: arrayUnion(userId) });
    }
  });

  await batch.commit();
}
